import Vue from "vue";
import Vuetify, { VContainer, VLayout } from "vuetify/lib";
import "vuetify/src/stylus/app.styl";
import "material-design-icons-iconfont/dist/material-design-icons.css";

Vue.use(Vuetify, {
  iconfont: "md",
  components: {
    VContainer,
    VLayout
  }
});
